module.exports = __webpack_public_path__ + "img/师资协调.f4057044.png";